import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { OperatorNoteDialogComponent, OperatorNoteDialogInput } from 'src/app/review/operator-note-dialog/operator-note-dialog.component';
import Task from 'src/models/task';
import TaskEvent, { OperatorNote } from 'src/models/task-event';

@Component({
  selector: 'app-task-bottom-sheet',
  templateUrl: './task-bottom-sheet.component.html',
  styleUrls: ['./task-bottom-sheet.component.scss']
})
export class TaskBottomSheetComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private bottomSheetRef: MatBottomSheetRef<TaskBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public model: Task,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  get isAnnotatable(): boolean { return this.latestAnnotatableTaskEvent !== null; }
  get latestAnnotatableTaskEvent(): TaskEvent | null { return this.model.events.filter(item => item.type !== 'Stop').slice(-1)[0] || null; };

  get hasNote(): boolean { return (this.latestAnnotatableTaskEvent?.operatorNoteReason || null) !== null; }
  get assignees(): string { return this.model.assignees.join(', '); }

  editOperatorNote = (): MatDialogRef<OperatorNoteDialogComponent, OperatorNote> | null => {
    const operatorNote: OperatorNote | null = this.latestAnnotatableTaskEvent;
    if (!operatorNote) {
      return null;
    }

    const taskEventId = this.latestAnnotatableTaskEvent!.id;
    const handle = this.dialog.open<OperatorNoteDialogComponent, OperatorNoteDialogInput, OperatorNote>(
      OperatorNoteDialogComponent,
      {
        data: { taskName: this.model.name, operatorNote, mode: 'edit' },
      });

    handle.afterClosed().subscribe((result?: OperatorNote) => {
      if (result) {
        operatorNote.operatorNoteReason = result.operatorNoteReason;
        operatorNote.operatorNote = result.operatorNote;
        this.apiService.saveOperatorNote(taskEventId, operatorNote);
      }
    });
    return handle;
  }

  removeOperatorNote = (): MatDialogRef<OperatorNoteDialogComponent, OperatorNote> | null => {
    const operatorNote: OperatorNote | null = this.latestAnnotatableTaskEvent;
    if (!operatorNote) {
      return null;
    }

    const taskEventId = this.latestAnnotatableTaskEvent!.id;
    const handle = this.dialog.open<OperatorNoteDialogComponent, OperatorNoteDialogInput, OperatorNote>(
      OperatorNoteDialogComponent,
      {
        data: { taskName: this.model.name, operatorNote, mode: 'remove' },
      });

    handle.afterClosed().subscribe((result?: OperatorNote) => {
      if (result) {
        operatorNote.operatorNoteReason = null;
        operatorNote.operatorNote = null;
        this.apiService.saveOperatorNote(taskEventId, null);
      }
    });
    return handle;
  }

  update(input: Task) {
    this.model = input;
  }

  close = (): void => {
    this.bottomSheetRef.dismiss();
  }
}
